import { Injectable, ɵɵdefineInjectable, Component, Input, NgModule } from '@angular/core';
import { stringify, parse } from 'query-string';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function NgxDeeplinkerComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "button", 1);
    ɵngcc0.ɵɵlistener("click", function NgxDeeplinkerComponent_ng_container_0_Template_button_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r1.handleDeeplinkClick($event)); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.config.displayLabel);
} }
class NgxDeeplinkerService {
    constructor() { }
    /**
     * @return {?}
     */
    getSourceUrl() {
        return window.location.origin + window.location.pathname;
    }
    /**
     * @param {?} config
     * @return {?}
     */
    handleDeeplinkClick(config) {
        /** @type {?} */
        const urlTokens = this.getUrlTokens();
        /** @type {?} */
        let formTokens = this.getFormTokens();
        /** @type {?} */
        const appParams = Object.assign({}, urlTokens);
        /** @type {?} */
        let hops = {};
        formTokens.source = this.getSourceUrl();
        formTokens.idToPopulate = config.idToPopulate || '';
        formTokens = stringify(formTokens);
        if (urlTokens.hops) {
            hops = parse(urlTokens.hops, { arrayFormat: 'bracket' });
        }
        if (hops.hops && hops.hops.length > 0) {
            hops.hops.push(config.appPrefix);
        }
        else {
            hops = { hops: [config.appPrefix] };
        }
        appParams[config.appPrefix] = formTokens;
        appParams['appPrefix'] = config.appPrefix;
        appParams['hops'] = stringify(hops, { arrayFormat: 'bracket' });
        /** @type {?} */
        const deeplinkUrl = this.createDeeplinkUrl(appParams, config.destinationUrl, config.additionalQueryParams);
        this.navigateTo(deeplinkUrl);
    }
    /**
     * @param {?} appPrefix
     * @return {?}
     */
    getReturnData(appPrefix) {
        if (appPrefix) {
            /** @type {?} */
            const urlTokens = this.getUrlTokens();
            /** @type {?} */
            const returnData = parse(urlTokens[appPrefix]);
            return typeof (returnData) === 'object' ? returnData : {};
        }
        return {};
    }
    /**
     * @return {?}
     */
    getFormTokens() {
        /** @type {?} */
        const elements = (/** @type {?} */ ((/** @type {?} */ (document.querySelectorAll('[data-url-persist]')))));
        /** @type {?} */
        const formFields = {};
        for (let fieldIndex = 0; fieldIndex < elements.length; fieldIndex++) {
            formFields[elements[fieldIndex].id] = elements[fieldIndex].value;
        }
        return formFields;
    }
    /**
     * @return {?}
     */
    getUrlTokens() {
        /** @type {?} */
        const urlQueryParams = window.location.search;
        return parse(urlQueryParams);
    }
    /**
     * @param {?} params
     * @param {?} destinationUrl
     * @param {?} additionalQueryParams
     * @return {?}
     */
    createDeeplinkUrl(params, destinationUrl, additionalQueryParams) {
        /** @type {?} */
        const allParams = Object.assign({}, params, additionalQueryParams);
        /** @type {?} */
        const allParamsString = stringify(allParams);
        return `${destinationUrl}?${allParamsString}`;
    }
    /**
     * @param {?} url
     * @return {?}
     */
    navigateTo(url) {
        document.location.href = url;
    }
    /**
     * @param {?} options
     * @return {?}
     */
    returnHandler(options) {
        /** @type {?} */
        let hops = {};
        /** @type {?} */
        const urlTokens = this.getUrlTokens();
        if (urlTokens.hops) {
            hops = parse(urlTokens.hops, { arrayFormat: 'bracket' });
        }
        if (this.shouldSubmit(hops)) {
            this.handleReturn(hops, options);
        }
        else {
            return;
        }
    }
    /**
     * @private
     * @param {?} hops
     * @param {?} options
     * @return {?}
     */
    handleReturn(hops, options) {
        /** @type {?} */
        const urlTokens = this.getUrlTokens();
        /** @type {?} */
        const currentApp = hops.hops.pop();
        /** @type {?} */
        const originTokens = parse(urlTokens[currentApp]);
        urlTokens.hops = stringify(hops, { arrayFormat: 'bracket' });
        if (options.callbackValue) {
            originTokens[originTokens.idToPopulate] = options.callbackValue;
        }
        urlTokens[currentApp] = stringify(originTokens);
        urlTokens.appPrefix = currentApp;
        if (urlTokens[options.appPrefix]) {
            delete urlTokens[options.appPrefix];
        }
        /** @type {?} */
        const deeplinkUrl = this.createDeeplinkUrl(urlTokens, originTokens.source, options.additionalQueryParams);
        this.navigateTo(deeplinkUrl);
    }
    /**
     * @private
     * @param {?} hops
     * @return {?}
     */
    shouldSubmit(hops) {
        return hops.hops && hops.hops.length > 0;
    }
}
NgxDeeplinkerService.ɵfac = function NgxDeeplinkerService_Factory(t) { return new (t || NgxDeeplinkerService)(); };
NgxDeeplinkerService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NgxDeeplinkerService, factory: NgxDeeplinkerService.ɵfac, providedIn: 'root' });
/** @nocollapse */
NgxDeeplinkerService.ctorParameters = () => [];
/** @nocollapse */ NgxDeeplinkerService.ngInjectableDef = ɵɵdefineInjectable({ factory: function NgxDeeplinkerService_Factory() { return new NgxDeeplinkerService(); }, token: NgxDeeplinkerService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxDeeplinkerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DeeplinkerConfig {
    /**
     * @param {?=} appPrefix
     * @param {?=} destinationUrl
     * @param {?=} idToPopulate
     * @param {?=} displayLabel
     * @param {?=} callbackValue
     * @param {?=} additionalQueryParams
     */
    constructor(appPrefix, destinationUrl, idToPopulate, displayLabel, callbackValue, additionalQueryParams) {
        this.appPrefix = appPrefix;
        this.destinationUrl = destinationUrl;
        this.idToPopulate = idToPopulate;
        this.displayLabel = displayLabel;
        this.callbackValue = callbackValue;
        this.additionalQueryParams = additionalQueryParams;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxDeeplinkerComponent {
    /**
     * @param {?} ngxDeepLinkerService
     */
    constructor(ngxDeepLinkerService) {
        this.ngxDeepLinkerService = ngxDeepLinkerService;
        this._config = new DeeplinkerConfig();
    }
    /**
     * @param {?} config
     * @return {?}
     */
    set config(config) {
        this._config = config;
    }
    /**
     * @return {?}
     */
    get config() {
        return this._config;
    }
    /**
     * @return {?}
     */
    ngOnInit() { }
    /**
     * @param {?} e
     * @return {?}
     */
    handleDeeplinkClick(e) {
        e.preventDefault();
        this.ngxDeepLinkerService.handleDeeplinkClick(this.config);
    }
}
NgxDeeplinkerComponent.ɵfac = function NgxDeeplinkerComponent_Factory(t) { return new (t || NgxDeeplinkerComponent)(ɵngcc0.ɵɵdirectiveInject(NgxDeeplinkerService)); };
NgxDeeplinkerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxDeeplinkerComponent, selectors: [["lib-ngx-deeplinker"]], inputs: { config: "config" }, decls: 1, vars: 1, consts: [[4, "ngIf"], [1, "x-btn-secondary", 3, "click"]], template: function NgxDeeplinkerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, NgxDeeplinkerComponent_ng_container_0_Template, 3, 1, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.appPrefix && ctx.config.destinationUrl && ctx.config.idToPopulate && ctx.config.displayLabel);
    } }, dependencies: [ɵngcc1.NgIf], encapsulation: 2 });
/** @nocollapse */
NgxDeeplinkerComponent.ctorParameters = () => [
    { type: NgxDeeplinkerService }
];
NgxDeeplinkerComponent.propDecorators = {
    config: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxDeeplinkerComponent, [{
        type: Component,
        args: [{
                selector: 'lib-ngx-deeplinker',
                template: `
      <ng-container *ngIf="config.appPrefix && config.destinationUrl && config.idToPopulate && config.displayLabel">
          <button class="x-btn-secondary" (click)="handleDeeplinkClick($event)"
          >{{config.displayLabel}}</button>
      </ng-container>
  `
            }]
    }], function () { return [{ type: NgxDeeplinkerService }]; }, { config: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxDeeplinkerModule {
}
NgxDeeplinkerModule.ɵfac = function NgxDeeplinkerModule_Factory(t) { return new (t || NgxDeeplinkerModule)(); };
NgxDeeplinkerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxDeeplinkerModule });
NgxDeeplinkerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [NgxDeeplinkerService], imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxDeeplinkerModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                providers: [NgxDeeplinkerService],
                declarations: [
                    NgxDeeplinkerComponent
                ],
                exports: [
                    NgxDeeplinkerComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxDeeplinkerModule, { declarations: function () { return [NgxDeeplinkerComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NgxDeeplinkerComponent]; } }); })();

export { NgxDeeplinkerComponent, NgxDeeplinkerModule, NgxDeeplinkerService };

